const enum DateFormat {
  '24_HOURS_FORMAT_WITH_SECONDS' = '[24-hours-format-with-seconds]',
  '24_HOURS_FORMAT' = '[24-hours-format]',
  DATE_WITHOUT_YEAR = '[date-without-year]',
  SHORT_DATE_WITHOUT_YEAR = '[short-date-without-year]',
  DAY_OF_WEEK_ABBREV_COMMA_MONTH_DAY = '[day-of-week-abbrev-comma-month-day]',
  DAY_OF_WEEK_MONTH_DAY_COMMA_AT_FULL_TIME_WITH_MERIDIAN = '[day-of-week-month-day-comma-at-full-time-with-meridian]',
  DAY_OF_WEEK_MONTH_DAY_COMMA_YEAR_FULL_TIME_WITH_MERIDIAN_AND_SPACE =
  '[day-of-week-month-day-comma-year-full-time-with-meridian-and-space]',
  DAY_OF_WEEK_MONTH_DAY_COMMA_YEAR = '[day-of-week-month-day-comma-year]',
  DAY_OF_WEEK_MONTH_DAY = '[day-of-week-month-day]',
  FULL_DATE_COMMA_PIPE_TIME = '[full-date-comma-pipe-time]',
  FULL_DATE_COMMA = '[full-date-comma]',
  FULL_DATE_COMMA_SHORT = '[full-date-comma-short]',
  FULL_DATE_TIME_AT = '[full-date-time-at]',
  FULL_DATE_TIME_SHORT_WITH_PIPE = '[full-date-time-short-with-pipe]',
  FULL_DATE_TIME_WITH_PIPE = '[full-date-time-with-pipe]',
  FULL_DATE_TIME = '[full-date-time]',
  FULL_DATE_YEAR_ABBREV = '[full-date-year-abbrev]',
  SHORT_DATE_YEAR_ABBREV = '[short-date-year-abbrev]',
  FULL_TIME_WITH_MERIDIAN_AND_SPACE = '[full-time-with-meridian-and-space]',
  FULL_TIME_WITH_MERIDIAN = '[full-time-with-meridian]',
  FULL_TIME_WITHOUT_MERIDIAN = '[full-time-without-meridian]',
  MONTH_AND_DAY = '[month-and-day]',
  MONTH_AND_YEAR = '[month-and-year]',
  ONLY_FULL_DAY = '[only-full-day]',
  ONLY_MERIDIAN = '[only-meridian]',
  TIME_WITH_MERIDIAN_UPPER = '[time-with-meridian-upper]',
  TIME_WITH_MERIDIAN = '[time-with-meridian]',
}

export default DateFormat
